import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Box, Container, Typography, Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Hero from '../../sections/Hero';
import QuoteRequestForm from '../../sections/QuoteRequestForm';

const FaqPage: React.FC = () => {
  const faqs = [
    {
      id: 'service-areas',
      question: "What areas do you service?",
      answer: "We service all of Northeast Wisconsin, including Green Bay, Door County, Appleton, Oshkosh, and surrounding communities. We're proud to serve the entire Door County peninsula, including Sturgeon Bay, Fish Creek, Egg Harbor, and Sister Bay. If you're unsure if we service your area, please contact us!"
    },
    {
      id: 'delivery-cost',
      question: "How much does delivery service cost?",
      answer: "Our delivery services start at $75, with final pricing based on distance, item size, and any special handling requirements. Contact us for a personalized quote."
    },
    {
      id: 'same-day-delivery',
      question: "Do you offer same-day delivery?",
      answer: "Yes, we offer same-day delivery when schedule availability permits. For the best chance of same-day service, we recommend contacting us as early as possible."
    },
    {
      id: 'junk-removal-items',
      question: "What items do you accept for junk removal?",
      answer: "We accept most household and commercial items for junk removal, including furniture, appliances, electronics, yard waste, and construction debris. We do not accept hazardous materials, such as chemicals, paints, or certain electronics. Please contact us if you're unsure about a specific item."
    },
    {
      id: 'licensed-insured',
      question: "Are you licensed and insured?",
      answer: "Yes, JBR Delivery LLC is fully licensed and insured for all our services, including delivery, junk removal, and moving services."
    },
    {
      id: 'schedule-service',
      question: "How do I schedule a service?",
      answer: "You can schedule a service by calling us at (920) 255-8952, filling out our online quote request form, or sending us an email. We'll respond promptly to discuss your needs and schedule a convenient time."
    },
    {
      id: 'commercial-services',
      question: "Do you offer commercial services?",
      answer: "Yes, we offer all our services for commercial clients, including regular delivery routes, office moves, and commercial junk removal."
    },
    {
      id: 'payment-methods',
      question: "What forms of payment do you accept?",
      answer: "We accept cash, checks, and all major credit cards. Payment is typically due upon completion of service."
    }
  ];

  return (
    <>
      <Helmet>
        <title>Frequently Asked Questions</title>
        <meta
          name="description"
          content="Find answers to common questions about JBR Delivery's services, pricing, service areas, and more."
        />
      </Helmet>

      <Hero 
        title="Frequently Asked Questions"
        subtitle="Find answers to common questions about our services"
        backgroundImage="/assets/images/faq-bg.jpg"
        showQuickForm={false}
      />

      <Box component="section" py={8}>
        <Container maxWidth="lg">
          <Typography variant="h2" component="h2" gutterBottom align="center" sx={{ mb: 6 }}>
            Common Questions
          </Typography>
          
          <Box>
            {faqs.map((faq) => (
              <Accordion key={faq.id} sx={{ mb: 2 }}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls={`panel-${faq.id}-content`}
                  id={`panel-${faq.id}-header`}
                >
                  <Typography variant="h6" fontWeight={500}>
                    {faq.question}
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography variant="body1">
                    {faq.answer}
                  </Typography>
                </AccordionDetails>
              </Accordion>
            ))}
          </Box>
          
          <Box mt={6}>
            <Typography variant="body1" paragraph align="center">
              Don't see your question answered? Contact us and we'll be happy to help!
            </Typography>
          </Box>
        </Container>
      </Box>

      <QuoteRequestForm />
    </>
  );
};

export default FaqPage;
